import userSlice from "./slice";
import * as selectors from "./selectors";
import * as actions from "./actions";

export const UserActions = { ...actions, ...userSlice.actions };
export const UserReducer = userSlice.reducer;
export const UserSelectors = selectors;
